var map = {
	"./app/matchs/view.vue": 9251,
	"./app/secrets/new.vue": 8115,
	"./auth/intro.vue": 4220,
	"./auth/login.vue": 400,
	"./auth/recoverpass.vue": 3850,
	"./auth/register.vue": 3463,
	"./index.vue": 2941,
	"./lang.vue": 2038
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9350;